import React from "react";
import {ShiftsDateFilterSection} from "../styles/CustomerShiftsPage.styles";
import CustomerShiftsDateRangeFilter from "./CustomerShiftsDateRangeFilter";
import DedicatedIntegrationPoolShiftTable from "./DedicatedIntegrationPoolShiftTable";

const PlannedShiftsTab = ({filters, setFilters, currentPage, setCurrentPage, loading, data}) => {
    return (
        <>
            <ShiftsDateFilterSection>
                <CustomerShiftsDateRangeFilter
                    filters={filters}
                    setFilters={setFilters}
                    setCurrentPage={setCurrentPage}
                    type="planned"
                />
            </ShiftsDateFilterSection>
            <DedicatedIntegrationPoolShiftTable
                loading={loading}
                data={data?.rows || []}
                dataCount={data?.dataCount}
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                hideActualShiftColumn={true}
                hideStatusColumn={true}
                hideDurationColumn={true}
                hidePackageCountColumn={true}
            />
        </>
    );
};

export default PlannedShiftsTab;
